import { featureFactory } from 'features';
import { FeatureNames } from '../flags';

type ExtendedProps = {
  causeId?: string;
};
const {
  IfFeatureState: IfFeatureState_Store,
  FeatureProvider,
  useFeatureFlag: useFeatureFlag_Store,
  useFeaturesContext,
} = featureFactory<FeatureNames, ExtendedProps>();

export { FeatureProvider, IfFeatureState_Store, useFeatureFlag_Store, useFeaturesContext };
